
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 113.154 76.869","height":"290.527","width":"427.67"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"transform":"translate(-42.83 -45.765)","fill":"none","stroke":"#cecece"}},[_c('rect',{attrs:{"ry":"2.929","y":"49.048","x":"46.113","height":"70.304","width":"106.589","stroke-width":"6.565"}}),_c('path',{attrs:{"d":"M45.916 119.508L75.3 81.157","stroke-width":"6.273"}}),_c('path',{attrs:{"d":"M152.878 119.49l-29.875-38.316","stroke-width":"6.322"}}),_c('path',{attrs:{"d":"M46.113 49.048s48.683 97.894 106.59 0","stroke-width":"5.965"}})])])
          )
        }
      }
    